<template>
    <router-view></router-view>
</template>
<script>
  export default {
    name: 'App',
    data() {
      return {
        items: []
      }
    },
    components: {}
  }

</script>
<style>

</style>
